import "./styles.css";
import { useContext } from "react";
import {
  Box,
  IconButton,
  Tooltip,
  Container,
  Grid,
} from "@mui/material";
import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import { SidebarContext } from "../../../contexts/SidebarContext";
import Logo from "../../../shared/components/logo";
import HoverDropdown from "../../../shared/components/hoverDropdown";
import PropertyDropdown from "./PropertyDropDown";

function Header() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);

  return (
    <Container className="headerContainer">
      <Grid container className="subContainer" alignItems="center">
        <Grid item xs={2}>
          <Logo />
        </Grid>

        <Grid
          item
          xs={10}
          className="userContainer"
          sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
        >

            <PropertyDropdown />

          <HoverDropdown />

          <Box
            component="span"
            sx={{
              ml: 2,
              display: { lg: "none", xs: "inline-block" }
            }}
          >
            <Tooltip arrow title="Toggle Menu">
              <IconButton color="primary" onClick={toggleSidebar}>
                {!sidebarToggle ? (
                  <MenuTwoToneIcon fontSize="small" />
                ) : (
                  <CloseTwoToneIcon fontSize="small" />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Header;
